<div class="mb-4 flex bg-blue-200 p-4 text-lg" *ngIf="router.url == '/profile/applications/4/seasons/25'">
  <button class="znak-blue mr-4">
    !
  </button>
  <div class="text-blue-600">
    <p class="mb-1 text-center uppercase font-bold">
      {{ 'pvo-textv' | translate }}
    </p>
    <div style="font-size: medium" class="text-blue-600">
            <span *ngIf="translate.currentLang == 'kz'">
               <li>
                 Докторантураға түсуші ҰТО ақпараттық жүйесі арқылы докторантураға түсу емтиханына қатысуға өтініш бергенге дейін ЖОО-ға құжаттардың толық топтамасын тапсыруы қажет.
               </li>
              <li>
                 Докторантураға түсу емтиханын өткізу орны, күні мен уақыты туралы ақпарат ағымдағы жылғы 9 тамызда түсушінің жеке кабинетінде «Менің іс-әрекетім» бөлімінде қолжетімді болады.
              </li>
              <li>
                2025-2026 оқу жылына PhD докторларын даярлауға арналған мемлекеттік білім беру тапсырысы.
              </li>
              <p>
                Толығырақ
                <a target="_blank" class="text-indigo-600"
                   [href]="'https://testcenter.kz/postupayushchim-v-doktoranturu/vazhnaya-informatsiya-dlya-uchastiya-v-konkurse-prisuzhdeniya-obrazovatelnogo-granta-2025-goda/spisok-obrazovatelnykh-grantov/'">
                   testcenter.kz
                </a>
              </p>
<!--                <p class="mt-2">-->
<!--                   2025-2026 оқу жылына магистрлерді даярлауға арналған мемлекеттік білім беру тапсырысы-->
<!--                </p>-->
<!--               <a target="_blank"-->
<!--                  href="https://testcenter.kz/ru/postupayushchim-v-magistraturu-i-doktoranturu/vazhnaya-informatsiya-dlya-uchastiya-v-konkurse-prisuzhdeniya-obrazovatelnogo-granta-2025-goda/spisok-obrazovatelnykh-grantov/"> <u>{{ 'podrob' | translate }}</u>-->
<!--              </a>-->
            </span>
      <span style="font-size: medium" *ngIf="translate.currentLang == 'ru'">
          <li>
            Поступающему в докторантуру необходимо подать полный пакет документов в ВУЗ до подачи заявления на участие во вступительном экзамене в докторантуру через информационную систему НЦТ.
          </li>
          <li>
            Информация о месте, дате и времени проведения вступительного экзамена в докторантуру будет доступна 9 августа текущего года в личном кабинете поступающего в разделе «Моя история».
          </li>
          <li>
             Государственный образовательный заказ на подготовку докторов PhD на 2025-2026 учебный год.
          </li>
          <p>
            Подраобнее
          <a target="_blank" class="text-indigo-600"
             [href]="'https://testcenter.kz/ru/postupayushchim-v-doktoranturu/vazhnaya-informatsiya-dlya-uchastiya-v-konkurse-prisuzhdeniya-obrazovatelnogo-granta-2025-goda/spisok-obrazovatelnykh-grantov/'">
             testcenter.kz
          </a>
          </p>
<!--                <p class="mt-2">Государственный образовательный заказ на подготовку магистров на 2025-2026 учебный год </p>-->
<!--              <a target="_blank"-->
<!--                 href="https://testcenter.kz/ru/postupayushchim-v-magistraturu-i-doktoranturu/vazhnaya-informatsiya-dlya-uchastiya-v-konkurse-prisuzhdeniya-obrazovatelnogo-granta-2025-goda/spisok-obrazovatelnykh-grantov/"> <u>{{ 'podrob' | translate }}</u>-->
<!--              </a>-->
        </span>
    </div>
  </div>
</div>







<div *ngIf="router.url == '/profile/applications/4/seasons/23'" class="mb-4 flex bg-blue-200 p-4 text-lg">
  <button class="znak-blue mr-4">
    !
  </button>
  <div class="text-blue-600">
    <p class="mb-1 text-center uppercase font-bold">
      {{ 'pvo-textv' | translate }}
    </p>
    <div class="text-blue-600">
            <span *ngIf="translate.currentLang == 'kz'">
                <p>Тестілеу орны мен уақыты туралы ақпарат ағымдағы жылғы <strong> 31 шілдеде </strong> түсушінің жеке кабинетінде «Менің іс-әрекетім» бөлімінде қолжетімді болады. </p>

            </span>

      <span *ngIf="translate.currentLang == 'ru'">
                <p>Информация о месте и времени проведения тестирования будет доступна <strong> 31 июля </strong> текущего года в личном кабинете поступающего в разделе «Моя история».</p>

            </span>
    </div>
  </div>
</div>


<div *ngIf="router.url == '/profile/applications/4/seasons/21'" class="mb-3 flex bg-blue-200 p-4 text-lg">
  <button class="znak-blue mr-4">
    !
  </button>
  <div class="text-blue-600">
    <div class="text-blue-600">
            <span *ngIf="translate.currentLang == 'kz'">

<!--                <p>Тестілеу орны мен уақыты туралы ақпарат ағымдағы жылғы <b>18 шілдеде</b> түсушінің жеке кабинетінде-->
              <!--                    «Менің-->
              <!--                    іс-әрекетім» бөлімінде қолжетімді болады.</p>-->
              <p>Тестілеу орны мен уақыты туралы ақпарат ағымдағы жылғы <b>13 қарашада </b> түсушінің жеке кабинетінде
                    «Менің
                    іс-әрекетім» бөлімінде қолжетімді болады.</p>


            </span>
      <span *ngIf="translate.currentLang == 'ru'">


<!--                <p> Информация о месте и времени проведения тестирования будет доступна <b>18 июля</b> текущего года в-->
        <!--                    личном кабинете поступающего в разделе «Моя история».</p>-->
              <p> Информация о месте и времени проведения тестирования будет доступна <b>13 ноября </b> текущего года в
                    личном кабинете поступающего в разделе «Моя история».</p>


            </span>
    </div>
  </div>
</div>


<div *ngIf="router.url == '/profile/applications/4/seasons/24'" class="mb-4 flex bg-blue-200 p-4 text-lg">
  <button class="znak-blue mr-4">
    !
  </button>
  <div class="text-blue-600">
    <p class="mb-1 text-center uppercase font-bold">
      {{ 'pvo-textv' | translate }}
    </p>
    <div class="text-blue-600">
            <span *ngIf="translate.currentLang == 'kz'">
                <p>Тестілеу орны мен уақыты туралы ақпарат ағымдағы жылғы <strong> 14 шілдеде </strong> түсушінің жеке кабинетінде «Менің іс-әрекетім» бөлімінде қолжетімді болады. </p>
                <p class="mt-2">
                   2025-2026 оқу жылына магистрлерді даярлауға арналған мемлекеттік білім беру тапсырысы
                </p>
               <a target="_blank"
                  href="https://testcenter.kz/ru/postupayushchim-v-magistraturu-i-doktoranturu/vazhnaya-informatsiya-dlya-uchastiya-v-konkurse-prisuzhdeniya-obrazovatelnogo-granta-2025-goda/spisok-obrazovatelnykh-grantov/"> <u>{{ 'podrob' | translate }}</u>
              </a>
            </span>

      <span *ngIf="translate.currentLang == 'ru'">
                <p>Информация о месте и времени проведения тестирования будет доступна <strong> 14 июля </strong> текущего года в личном кабинете поступающего в разделе «Моя история».</p>
                <p class="mt-2">Государственный образовательный заказ на подготовку магистров на 2025-2026 учебный год </p>
              <a target="_blank"
                 href="https://testcenter.kz/ru/postupayushchim-v-magistraturu-i-doktoranturu/vazhnaya-informatsiya-dlya-uchastiya-v-konkurse-prisuzhdeniya-obrazovatelnogo-granta-2025-goda/spisok-obrazovatelnykh-grantov/"> <u>{{ 'podrob' | translate }}</u>
              </a>
            </span>
    </div>
  </div>
</div>
<div *ngIf="this.router.url == '/profile/applications/' + appId +'/seasons/' + seasonId" class="flex flow">
  <div *ngFor="let appType of appTypeList" [routerLink]="this.router.url + '/' + appType.path"
       [queryParams]="{appTypeId: appType.id}"
       class="hover:bg-blue-200 type-box border border-dark p-3 m-2 rounded-lg cursor-pointer">
    <span *ngIf="translate.currentLang == 'kz'">{{ appType.name.kk }}</span>
    <span *ngIf="translate.currentLang == 'ru'">{{ appType.name.ru }}</span>
  </div>
</div>
<router-outlet></router-outlet>
<p *ngIf="router.url == '/profile/applications/4/seasons/9'" class="mb-2 text-center text-xl mt-2 text-blue-600">
  <!-- <span *ngIf="translate.currentLang == 'kz'">
      <a target="_blank" href="https://testcenter.kz/press-tsentr/novosti/?ELEMENT_ID=5116">{{ 'PvoSubTxt3' | translate }}</a>
  </span>
  <span *ngIf="translate.currentLang == 'ru'">
      <a target="_blank" href="https://testcenter.kz/ru/press-tsentr/novosti/?ELEMENT_ID=5117">{{ 'PvoSubTxt3' | translate }}</a>
  </span>
  <br> -->
  <span *ngIf="translate.currentLang == 'kz'">
        <a target="_blank" href="https://testcenter.kz/press-tsentr/novosti/?ELEMENT_ID=5453">{{
            'PvoSubTxt5' |
              translate
          }}</a>
    </span>
  <span *ngIf="translate.currentLang == 'ru'">
        <a target="_blank" href="https://testcenter.kz/ru/press-tsentr/novosti/?ELEMENT_ID=5452">{{
            'PvoSubTxt5' |
              translate
          }}</a>
    </span>
</p>
<p *ngIf="router.url == '/profile/applications/4/seasons/10'" class="mb-2 text-center text-xl mt-2 text-blue-600">
  <!-- <span *ngIf="translate.currentLang == 'kz'">
      <a target="_blank" href="https://testcenter.kz/press-tsentr/novosti/?ELEMENT_ID=5118">{{ 'PvoSubTxt4' | translate }}</a>
  </span>
  <span *ngIf="translate.currentLang == 'ru'">
      <a target="_blank" href="https://testcenter.kz/ru/press-tsentr/novosti/?ELEMENT_ID=5119">{{ 'PvoSubTxt4' | translate }}</a>
  </span>
  <br> -->
  <span *ngIf="translate.currentLang == 'kz'">
        <a target="_blank" href="https://testcenter.kz/press-tsentr/novosti/?ELEMENT_ID=5454">{{
            'PvoSubTxt6' |
              translate
          }}</a>
    </span>
  <span *ngIf="translate.currentLang == 'ru'">
        <a target="_blank" href="https://testcenter.kz/ru/press-tsentr/novosti/?ELEMENT_ID=5455">{{
            'PvoSubTxt6' |
              translate
          }}</a>
    </span>
</p>
